import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";

// Authentication Components
import Login from "../auth/login/login";

// Dashboard
import AdminDashboard from "../mainMenu/adminDashboard";

import Courses from "../pages/courses";
import Subscriptions from "../pages/subscriptions";
import MyAccount from "../pages/myAccount";
import Support from "../pages/support";
import OrderStatus from "../pages/order/status";
import Error404 from "../pages/error/error-404";
import UnderMaintenance from "../pages/underMaintenance";
import Profile from "../pages/profile";
import OrderSubscription from "../pages/order";
import Register from "../auth/register";
import ForgotPassword from "../auth/forgotPassword";
import ResetPassword from "../auth/resetPassword";
import OTPVerification from "../auth/otpVerification";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess";
const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.index,
    element: <Subscriptions />,
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  

  {
    path: routes.courses,
    element: <Courses />,
  },
  {
    path: routes.subscriptions,
    element: <Subscriptions />,
  },
  {
    path: routes.myAccount,
    element: <MyAccount />,
  },
  {
    path: routes.support,
    element: <Support />,
  },
  {
    path: routes.order,
    element: <OrderSubscription />,
  },
  {
    path: routes.orderStatus,
    element: <OrderStatus />,
  },
  {
    path: routes.profile,
    element: <Profile />,
  }
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route, 
  },
  {
    path: routes.otpVerification,
    element: <OTPVerification />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
    route: Route,
  }
];